import React from "react";

import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";

import { Table, Input, Select, Tag, Button } from "antd";
const { Option } = Select;

const EditableContext = React.createContext();

class EditableCell extends React.Component {
  renderCell = ({ getFieldDecorator }) => {
    const {
      editing,
      dataIndex,
      title,
      inputType,
      record,
      index,
      children,
      ...restProps
    } = this.props;

    let returnComponent = null;
    let usersOptions = [];
    // let selectedUsers = "";
    let selectedUsers = [];

    if (inputType === "select") {
      // console.log(this.props.userdata);
      // console.log(record._id, "dataIndex");
      let disableIds = [];
      if (this.props.disabledusers && this.props.disabledusers[record._id]) {
        disableIds = this.props.disabledusers[record._id];
      }

      this.props.userdata.forEach((d) => {
        usersOptions.push(
          // <Option key={"d" + d._id} value={d._id} disabled={ !disableIds.includes(d._id) &&  d.email ? false : true} >
          <Option
            key={"d" + d._id}
            value={d._id}
            disabled={d.email ? false : true}
          >
            {d.name} - {d.user_name} -{" "}
            {d.email ? d.email : <b>No user email</b>}
          </Option>
        );

        if (record[dataIndex].includes(d._id)) {
          // selectedUsers += d.name + " (" + d.userName + ")  \n";
          selectedUsers.push(
            <Tag key={d._id}>
              {d.name} - {d.user_name} - {d.email}
            </Tag>
          );
        }
      });
    }

    if (editing) {
      if (inputType === "text") {
        returnComponent = (
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator(dataIndex, {
              rules: [
                {
                  required: true,
                  message: `Please Input ${title}!`,
                },
              ],
              initialValue: record[dataIndex],
            })(<Input />)}
          </Form.Item>
        );
      }
      if (inputType === "select") {
        returnComponent = (
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator(dataIndex, {
              rules: [
                {
                  required: true,
                  message: "Please Enter User(s)",
                },
              ],
              initialValue: record[dataIndex],
            })(
              <Select
                mode="multiple"
                showSearch
                placeholder="Enter User(s)"
                optionFilterProp="children"
                notFoundContent={null}
                style={{ width: "100%" }}
              >
                {usersOptions}
              </Select>
            )}
          </Form.Item>
        );
      }
    } else {
      if (inputType === "select") {
        returnComponent = selectedUsers;
      } else {
        returnComponent = children;
      }
    }

    return <td {...restProps}>{returnComponent}</td>;
  };

  render() {
    return (
      <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
    );
  }
}

class EditableTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.signersGroupsGetData.signers_groups,
      editingKey: "",
    };

    this.columns = [
      {
        title: "Group Name",
        dataIndex: "signers_group_name",

        editable: true,
        inputType: "text",
      },

      {
        title: "User(s)",
        dataIndex: "signers_group_users",

        editable: true,
        inputType: "select",
      },
      {
        title: "Action",
        dataIndex: "operation",
        width: "220px",
        render: (text, record) => {
          const { editingKey } = this.state;
          const editable = this.isEditing(record);
          return editable ? (
            <span>
              <EditableContext.Consumer>
                {(form) => (
                  <Button
                    type="primary"
                    size="small"
                    onClick={() => this.save(form, record._id)}
                    style={{ marginRight: 8 }}
                  >
                    Save
                  </Button>
                )}
              </EditableContext.Consumer>

              <Button
                size="small"
                type="danger"
                onClick={() => this.cancel(record._id)}
              >
                Cancel
              </Button>
            </span>
          ) : (
            <Button
              type="primary"
              size="small"
              disabled={editingKey !== ""}
              onClick={() => this.edit(record._id)}
            >
              Edit
            </Button>
          );
        },
      },
    ];
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.data !== this.props.signersGroupsGetData.signers_groups) {
      this.setState({ data: this.props.signersGroupsGetData.signers_groups });
    }
  }

  isEditing = (record) => record._id === this.state.editingKey;

  cancel = () => {
    this.setState({ editingKey: "" });
  };

  save(form, key) {
    form.validateFields(async (error, values) => {
      if (error) {
        return;
      }

      let sendValues = {};
      sendValues._id = key;
      sendValues.signers_group_name = values.signers_group_name;
      sendValues.signers_group_users = values.signers_group_users;

      if (await this.props.saveGroup(sendValues)) {
        this.setState({ editingKey: "" });
      } else {
      }
    });
  }

  edit(key) {
    this.setState({ editingKey: key });
  }

  render() {
    const components = {
      body: {
        cell: EditableCell,
      },
    };

    const columns1 = [
      {
        title: "Group Name",
        dataIndex: "signers_group_name",
        editable: true,
        inputType: "text",
        width: "250px",
      },

      {
        title: "User(s)",
        dataIndex: "signers_group_users",
        editable: true,
        inputType: "select",
      },
      {
        title: "Action",
        dataIndex: "operation",
        width: "220px",
        render: (text, record) => {
          const { editingKey } = this.state;
          const editable = this.isEditing(record);
          return editable ? (
            <span>
              <EditableContext.Consumer>
                {(form) => (
                  <Button
                    type="primary"
                    size="small"
                    onClick={() => this.save(form, record._id)}
                    style={{ marginRight: 8 }}
                  >
                    Save
                  </Button>
                )}
              </EditableContext.Consumer>

              <Button
                size="small"
                type="danger"
                onClick={() => this.cancel(record._id)}
              >
                Cancel
              </Button>
            </span>
          ) : (
            <Button
              type="primary"
              size="small"
              disabled={editingKey !== ""}
              onClick={() => this.edit(record._id)}
            >
              Edit
            </Button>
          );
        },
      },
    ];

    const columns = columns1.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: (record) => ({
          record,
          inputType: col.inputType,
          dataIndex: col.dataIndex,
          title: col.title,
          editing: this.isEditing(record),
          userdata: this.props.signersGroupsGetData.users,
          disabledusers:
            this.props.signersGroupsGetData.signers_groups_disable_users,
        }),
      };
    });

    return (
      <EditableContext.Provider value={this.props.form}>
        <Table
          components={components}
          bordered
          dataSource={this.state.data}
          columns={columns}
          rowClassName="editable-row"
          rowKey="_id"
          pagination={false}
          className="is_table_4"
          scroll={{ x: 1200 }}
        />
      </EditableContext.Provider>
    );
  }
}

const EditableFormTable = Form.create()(EditableTable);

export default EditableFormTable;
